module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/featured-section@2x.2658df3.gif";